import request from '@/utils/request'


// 查询商家门店列表
export function listMerchantStore(query) {
  return request({
    url: '/biz/admin/merchant/store/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家门店分页
export function pageMerchantStore(query) {
  return request({
    url: '/biz/admin/merchant/store/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}


export function listSelectMerchantStore(query) {
  return request({
    url: '/biz/admin/merchant/store/list/select',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

export function pageSelectMerchantStore(query) {
  return request({
    url: '/biz/admin/merchant/store/page/select',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家门店详细
export function getMerchantStore(data) {
  return request({
    url: '/biz/admin/merchant/store/detail',
    method: 'get',
    params: data
  })
}

// 新增商家门店
export function addMerchantStore(data) {
  return request({
    url: '/biz/admin/merchant/store/add',
    method: 'post',
    data: data
  })
}

// 修改商家门店
export function updateMerchantStore(data) {
  return request({
    url: '/biz/admin/merchant/store/edit',
    method: 'post',
    data: data
  })
}

// 删除商家门店
export function delMerchantStore(data) {
  return request({
    url: '/biz/admin/merchant/store/delete',
    method: 'post',
    data: data
  })
}

export function storeStatus(data) {
  return request({
    url: '/biz/admin/merchant/store/status',
    method: 'post',
    data: data
  })
}